import { render, staticRenderFns } from "./SectionDefaultTickets.vue?vue&type=template&id=7abdd986&"
import script from "./SectionDefaultTickets.vue?vue&type=script&lang=js&"
export * from "./SectionDefaultTickets.vue?vue&type=script&lang=js&"
import style0 from "./SectionDefaultTickets.vue?vue&type=style&index=0&id=7abdd986&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports